export default __webpack_public_path__ + "static/media/starred.3f5eb997.svg";